import React from 'react';

const FilterToggle = ({ selectedFilterType, onToggleFilterType, disabled, entityType }) => (
  <>
    {entityType === 'events' && (
      <div className="flex gap-2 w-full">
        <button
          disabled={disabled}
          className={`flex-1 ${
            disabled ? 'bg-gray-300' : selectedFilterType === 'instructor' ? 'bg-primary-600' : 'bg-primary-300'
          } text-white py-2 rounded mt-2`}
          onClick={() => onToggleFilterType('instructor')}
        >
          Instructor
        </button>
        <button
          disabled={disabled}
          className={`flex-1 ${
            disabled ? 'bg-gray-300' : selectedFilterType === 'location' ? 'bg-primary-600' : 'bg-primary-300'
          } text-white py-2 rounded mt-2`}
          onClick={() => onToggleFilterType('location')}
        >
          Location
        </button>
      </div>
    )}
  </>
);

export default FilterToggle;
